import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import RelatorioAuditoriaFrequencia from './relatorio_auditoria_frequencia';
import RelatorioFrequenciaMensal from './relatorio_frequencia_mensal';
export default function RelatorioFrequencia() {
    var searchParams = useSearchParams()[0];
    var folhaId = searchParams.get('folhaId');
    if (folhaId) {
        return _jsx(RelatorioFrequenciaMensal, {});
    }
    return _jsx(RelatorioAuditoriaFrequencia, {});
}
